import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";

export const toLines = (arr) => (Array.isArray(arr) ? arr.join("\n") : "");
export const fromLines = (s) => String(s || "").split("\n").map((x) => x.trim()).filter(Boolean);

// One-item-per-line list editor. The text is kept exactly as the admin types it
// (a new empty line, a space before the next word) and only PARSED into the
// list; rebuilding the text from the list on every keystroke is what used to
// swallow Enter and trailing spaces, so nothing new could be typed in.
export default function LinesField({ value, onChange, ...props }) {
  const [text, setText] = useState(() => toLines(value));
  // A list changed from outside (CSV import, reload) replaces the draft; the
  // admin's own edits parse to the same list and leave it alone.
  useEffect(() => {
    setText((t) => (JSON.stringify(fromLines(t)) === JSON.stringify(Array.isArray(value) ? value : []) ? t : toLines(value)));
  }, [value]);
  return (
    <TextField
      {...props}
      multiline
      value={text}
      onChange={(e) => { setText(e.target.value); onChange(fromLines(e.target.value)); }}
    />
  );
}
